import { trackAnalyticsEvent } from './analytics';

export function trackHomeEvent(ev, props = {}) {
    const p = { ...props, page_variant: state.vKey };
    if (state.useCase && !p.use_case) p.use_case = state.useCase;
    trackAnalyticsEvent(ev, p);
}

const ASSET = '/static/homepage';

const VARIANTS = {
    web: {
        title: 'JPEGmini Cloud: Send the Whole Wedding in One Link',
        walls: 'wedding',
        say: {
            add: ['Drop the whole wedding. <span>Get one link back.</span>', 'Photos and films, a fraction of the size, visually identical. Ready to share in minutes.'],
        },
        c: {},
        nameSub: 'Your couple sees it at the top of their gallery.',
        namePh: 'Ana & Luis',
    },
    desktop: {
        title: 'JPEGmini Cloud for desktop users',
        walls: 'wedding',
        signupSource: 'desktop',
        say: {
            add: ['The JPEGmini you know. <span>Now in your browser.</span>', 'Drop the whole shoot, photos and films, and your client has one link the same night. The same JPEGmini compression as it uploads, plus AI story crops and face finding.'],
        },
        priceNote: 'Your JPEGmini desktop app stays yours, forever. Cloud is a separate subscription for delivery.',
        faq: [
            ['Do I need to install anything?', "No. Cloud runs in your browser on a Mac, a Windows PC or your phone. There's nothing to install, no updates and no license key: you sign in with your email."],
            ['Does it do everything the desktop app does?', 'It runs the same JPEGmini compression on photos and films as they upload, and adds the AI tools and the link to send. The desktop app stays the fastest way to compress on your own computer, with its GPU video engine, the Lightroom plugin and folder automations, and it stays yours forever.'],
            ['Do I need to run files through the desktop app first?', "No. Drop your exports straight in, and Cloud runs the same JPEGmini engine on them as they upload. If you've already run them through the desktop app, that works too."],
            ['What happens to my desktop license?', 'Nothing changes. Your JPEGmini desktop app stays yours, forever. Cloud is a separate subscription for delivery, and if you ever stop it, you keep the app exactly as it is.'],
            ['Is it the same engine as the desktop app?', 'Yes. The same JPEGmini technology you trust on your exports, now applied as you upload, to JPEGs, HEICs and MP4 or MOV films.'],
            ['Will my clients see a difference?', 'No. Photos keep their resolution, films keep their frames and grade. It\'s the same visually identical standard you already deliver with.'],
            ['Can I send films as well as photos?', 'Yes. The film, the teaser and the photos all go in one link, and the film plays straight away on a phone.'],
            ['Do links expire?', "On Pro and Studio, never: a link stays up until you delete it. On the Free plan, files are kept for 30 days, so you can try it on a real delivery."],
            ['Do my clients need an account or an app?', 'No. They open the link in any browser, watch the film, save their favorites and download everything.'],
            ['Can I put my own logo on the gallery?', 'Yes, on Pro and Studio. Your logo and links sit at the top of every gallery.'],
            ['Is the AI on by default, and is my work used to train it?', 'No to both. Face finding and story crops are off until you switch them on for a gallery, and your work is never used to train AI models or sold.'],
        ],
        c: {
            cmpH: 'The JPEGmini you already trust. Now for photos and films.',
            cmpP: 'It\'s the same engine you run on your exports, now working as you upload. JPEGs, HEICs and MP4 or MOV films all come out lighter, with every frame, every color and every bit of grain exactly as you made it.',
        },
        nameSub: 'Your client sees it at the top of their gallery.',
        namePh: 'Ana & Luis',
    },
    shoot: {
        title: 'JPEGmini Cloud: Send the Whole Shoot in One Link',
        walls: 'all',
        say: {
            add: ['Send the whole shoot. <span>One link.</span>', 'Photos and films from any session, a fraction of the size, visually identical. Ready to share in minutes.'],
        },
        c: {
            navSend: 'Send a shoot',
            cmpH: 'The whole shoot folder. A fraction of the size.',
            cmpP: 'Every photo and film from the shoot comes out lighter, at full resolution, with every color and every bit of grain exactly as you shot it.',
        },
        nameSub: 'Your client sees it at the top of their gallery.',
        namePh: 'Spring campaign, or Noa\'s bat mitzvah',
    },
    film: {
        title: 'JPEGmini Cloud: Your Film, Playing on Their Phone Tonight',
        walls: 'film',
        say: {
            add: ['Your 40 GB film. <span>Playing on their phone tonight.</span>', 'Drop in the film, the teaser and the photos. One link, half the size, your grade untouched.'],
        },
        c: {
            navSend: 'Send a film',
            addTitle: 'Add your film and photos',
            addSub: 'MP4, MOV and photos. Up to 5 GB free.',
        },
        nameSub: 'Your client sees it at the top of their gallery.',
        namePh: 'Ana & Luis',
    },
    htj: {
        title: 'Convert HEIC to JPG and share them in one link | JPEGmini Cloud',
        walls: 'everyday',
        signupSource: 'heictojpg',
        mode: 'download',
        optOrder: ['download', 'link', 'email'],
        fakePrints: true,
        hidePricing: true,
        say: {
            add: ['Convert HEIC to JPG, then share them in one link', 'Add every photo and video, up to 5 GB. Get them back as JPGs in one download, or send one album link to anyone.'],
            work: ['Converting your photos', 'Create your free account while they upload. Then choose what to do with them.'],
            done: ['All converted', 'Download them, or share one album link.'],
        },
        proofLine: 'From the team behind heictojpg.com and JPEGmini',
        c: {
            private: 'Free with your email. Kept for 30 days, then deleted.',
            navSend: 'Convert photos',
            addTitle: 'Choose photos and videos',
            addSub: 'or drop them here. HEIC, JPG, MP4 and MOV.',
            addSubTouch: 'HEIC, JPG, MP4 and MOV. Up to 5 GB free.',
            dropH: 'Drop to convert',
            dropP: 'Photos and videos. We start straight away.',
            example: 'See an example album',
            nameQ: 'What\'s the album called?',
            toQ: 'What do you want to do with them?',
            optDown: 'Download them',
            optDownSub: 'Every photo as a JPG, in one zip. A copy stays in your account.',
            optLink: 'Get a link to share',
            optLinkSub: 'Send it yourself, by WhatsApp, Messages or email.',
            optEmail: 'Email it to someone',
            optEmailSub: 'We send them the album link.',
            dlBtn: 'Download all',
            again: 'Convert more',
        },
        t: {
            go: { email: 'Send it', link: 'Get my link', download: 'Download my JPGs' },
            eTo: 'Add their email, or choose Get a link to share.',
            eName: 'Give it a name, so you can find it later.',
            badType: 'Add HEIC, JPEG, MP4 or MOV files.',
            readyDown: 'Your JPGs are ready',
            readyLink: 'Your album is ready',
            leadLink: 'Copy it or share it with anyone.',
            pct: ['Converting', 'Building the album', 'Album ready'],
            shareText: 'Here are the photos.',
        },
        nameSub: 'So you, and whoever you share it with, can find it.',
        namePh: 'Weekend in Lisbon',
        toPh: 'Their email',
        msgPh: 'Here are the photos.',
    },
};

const EVERYDAY_WALLS = [
    { src: 'h0.jpg', pos: '35% 55%', posM: '62% 50%', by: 'Gene Gallin', note: 'on Unsplash', url: 'https://unsplash.com/photos/FACoCDNSQaE' },
    { src: 'h1.jpg', pos: '40% 60%', posM: '20% 55%', by: 'Marcus Lenk', note: 'on Unsplash', url: 'https://unsplash.com/photos/wKO0rx50VWo' },
    { src: 'h2.jpg', pos: '50% 26%', posM: '50% 35%', by: 'Dhaya Eddine Bentaleb', note: 'on Unsplash', url: 'https://unsplash.com/photos/PIoVxaujRRY' },
    { src: 'h3.jpg', pos: '50% 40%', posM: '52% 40%', by: 'Fares Hamouche', note: 'on Unsplash', url: 'https://unsplash.com/photos/KFxhaD505GU' },
];

const DESK_TILES = {
    i0: 'g/b28.jpg', i1: 'g/b726.jpg', i2: 'g/b677.jpg', i3: 'g/b781.jpg', i4: 'g/b854.jpg',
    i5: 'g/b699.jpg', i6: 'g/b700.jpg', i7: 'g/b728.jpg', i8: 'g/b706.jpg', i9: 'g/b860.jpg',
    i10: 'g/b679.jpg', i11: 'g/b673.jpg', i12: 'g/b220.jpg', i13: 'g/b226.jpg', i14: 'g/b201.jpg', i15: 'g/b726.jpg',
};

let state = {
    vKey: 'web',
    V: VARIANTS.web,
    T: {},
    useCase: null,
};

function $(id) { return document.getElementById(id); }

export function resolveVariantKey() {
    if (window.__PUBLIC_HOME_VARIANT) return window.__PUBLIC_HOME_VARIANT;
    const path = window.location.pathname;
    if (/heictojpg/.test(path)) return 'htj';
    if (/desktop/.test(path)) return 'desktop';
    const qv = new URLSearchParams(window.location.search).get('v');
    if (VARIANTS[qv]) return qv;
    if (/shoot|photographers/.test(path)) return 'shoot';
    if (/film/.test(path)) return 'film';
    return 'web';
}

const END_HEADLINE = {
    web: 'Your next wedding, one link.',
    desktop: 'Your next wedding, one link.',
    shoot: 'Your next shoot, one link.',
    film: 'Your next film, one link.',
};

export function getPublicHomeVariant() {
    return state;
}

const HERO_WALLS = [
    { src: 'wall-bouquet.jpg', pos: '40% 35%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/', tags: ['wedding'] },
    { src: 'wall-parasols.jpg', pos: '50% 55%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/', tags: ['wedding'] },
    { src: 'hero-betto.jpg', pos: '50% 45%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/', tags: ['wedding'] },
    { video: 'film-a.mp4', poster: 'hero-betto.jpg', pos: '50% 45%', by: 'Betto Robles', url: 'https://www.instagram.com/bettoroblesfotografo/', tags: ['film'], placeholder: true },
];

export function getWallsForVariant(vKey) {
    const V = VARIANTS[vKey] || VARIANTS.web;
    const everyday = EVERYDAY_WALLS.map((w) => ({ ...w, tags: ['everyday'] }));
    let walls = [...HERO_WALLS, ...everyday];
    if (V.walls === 'everyday') {
        return everyday.length ? everyday : [];
    }
    if (V.walls === 'all') {
        walls = walls.filter((w) => !(w.tags || []).includes('everyday'));
        return walls.length ? walls : HERO_WALLS.filter((w) => (w.tags || []).includes('wedding'));
    }
    if (V.walls !== 'all') {
        const only = walls.filter((w) => (w.tags || []).includes(V.walls));
        if (only.length) return only;
        if (V.walls === 'wedding') {
            return HERO_WALLS.filter((w) => (w.tags || []).includes('wedding'));
        }
    }
    return HERO_WALLS.filter((w) => (w.tags || []).includes('wedding'));
}

function assetBg(key) {
    if (DESK_TILES[key]) return `${ASSET}/${DESK_TILES[key].replace(/\.jpe?g$/i, '.webp')}`;
    if (/^[hpgre]\d+$/i.test(key)) return `${ASSET}/${key}.jpg`;
    return `${ASSET}/${key}.jpg`;
}

function applyCopy() {
    const { V } = state;
    if (V.proofLine) {
        const proof = document.querySelector('.say-proof');
        if (proof) proof.textContent = V.proofLine;
    }
    if (V.c?.addSubTouch && window.matchMedia('(hover: none) and (pointer: coarse)').matches) {
        V.c.addSub = V.c.addSubTouch;
    }
    document.title = V.title;
    Object.keys(V.c || {}).forEach((k) => {
        document.querySelectorAll(`[data-c="${k}"]`).forEach((n) => { n.textContent = V.c[k]; });
    });
    ['namePh', 'toPh', 'msgPh'].forEach((k) => {
        if (V[k]) document.querySelectorAll(`[data-ph="${k}"]`).forEach((n) => { n.placeholder = V[k]; });
    });
    if (V.nameSub && $('nameSub')) $('nameSub').textContent = V.nameSub;
    if (V.priceNote) {
        const dn = $('deskNote');
        if (dn) { dn.textContent = V.priceNote; dn.hidden = false; }
    }
    if (V.faq) {
        const esc = (t) => { const d = document.createElement('div'); d.textContent = t; return d.innerHTML; };
        const faq = document.querySelector('#value .m-faq .faq');
        if (faq) faq.innerHTML = V.faq.map((qa) => `<details><summary>${esc(qa[0])}</summary><p>${esc(qa[1])}</p></details>`).join('');
    }
    if (V.hidePricing) {
        document.querySelectorAll('.top nav a[href="#pricing"], .foot nav a[href="#pricing"]').forEach((a) => { a.hidden = true; });
    }
    const endLine = END_HEADLINE[state.vKey];
    if (endLine && $('endH')) $('endH').textContent = endLine;
    document.querySelectorAll('.vpick a').forEach((a) => {
        a.setAttribute('aria-current', a.dataset.v === state.vKey ? 'true' : 'false');
    });
}

function layoutForVariant() {
    const { vKey } = state;
    if (vKey === 'htj') {
        $('value')?.remove();
        const htj = $('valueHtj');
        if (htj) htj.hidden = false;
        document.querySelectorAll('.top nav a[href^="#"]:not(.cta)').forEach((a) => {
            if (a.getAttribute('href') === '#how') a.setAttribute('href', '#valueHtj');
            else a.hidden = true;
        });
    }
    if (vKey === 'desktop' && $('hUse')) {
        setupDesktopUseSection();
    }
}

function setupDesktopUseSection() {
    const hUse = $('hUse');
    const ai = document.querySelector('#value .m-ai');
    const how = document.querySelector('#value #how');
    if (hUse && ai) ai.parentNode.insertBefore(hUse, ai.nextSibling);
    else if (hUse && how) how.parentNode.insertBefore(hUse, how.nextSibling);
    const howEl = document.querySelector('#value #how');
    if (howEl) {
        const h2 = howEl.querySelector('h2');
        if (h2) h2.innerHTML = 'From export to client, <span>in one step.</span>';
        const fc = howEl.querySelectorAll('figcaption');
        if (fc.length === 3) {
            fc[0].textContent = 'Drop your exports';
            fc[1].textContent = 'Compressed as it uploads';
            fc[2].textContent = 'Your client has the link';
        }
        const fn = howEl.querySelector('.flow-note');
        if (fn) fn.textContent = 'No separate compress, upload and gallery steps. Switch on story crops and face finding, and they\'re ready in the same gallery.';
    }
    document.querySelector('#value .m-watch')?.setAttribute('hidden', '');
    document.querySelector('#value .m-cmp-sec')?.setAttribute('hidden', '');
    if ($('evSecH')) $('evSecH').textContent = 'What do you send after a shoot?';
    if ($('evSecP')) $('evSecP').textContent = 'Pick one to see how it works with Cloud.';
    $('evTabs')?.setAttribute('aria-label', 'What you send after a shoot');
    if ($('evActsH')) $('evActsH').textContent = 'What you can do';
    if ($('useText')) $('useText').placeholder = 'For example, an album proof for the parents';
}

function initUseCases({ focusCard, setMode }) {
    const T_ = (k, p, sz = 'cover', lab) => [k, p, sz, lab];
    let EV = {
        graduation: {
            h: 'Graduation photos, for the whole family',
            p: 'Convert every photo from the day, then send one album to the family chat. It opens on Grandma\'s Windows laptop too.',
            a: [['link', 'Share one album link'], ['email', 'Email the album to family'], ['door:prints', 'Order prints'], ['download', 'Download them all']],
            album: ['Class of 2026', 'Graduation day · 212 photos, 3 videos'],
            tiles: [T_('g1', '50% 55%'), T_('h2', '50% 28%'), T_('g2', '50% 75%'), T_('h3', '50% 38%'), T_('g0', '55% 40%'), T_('h3', '52% 36%'), T_('g4', '50% 50%'), T_('g3', '50% 45%'), T_('g1', '45% 12%', '220%'), T_('g2', '85% 75%', '230%'), T_('g0', '50% 85%', '200%'), T_('g4', '25% 70%', '210%')],
            chat: ['Family', 'Mom, Dad, Grandma, Leo', 'g1', 'Class of 2026, all 212 photos', 'Every photo from today, full size', 'Grandma', 'Finally they open on my computer!', 'Leo', 'Saving the one with the caps'],
            cap2: 'The family chat',
        },
        listing: {
            h: 'Listing photos, ready to send',
            p: 'Your iPhone shots become JPGs that listing sites accept, at full resolution. Send a whole set of homes to your client in one link.',
            a: [['download', 'Download JPGs for the listing site', 'Full-resolution JPGs, ready to upload.'], ['link', 'Send the set to my client', 'One link with every home, for your client to browse.'], ['email', 'Email them to someone'], ['door:size_limit', 'Fit a size limit per photo']],
            album: ['Saturday showings', '5 homes · 64 photos'],
            tiles: [T_('e3', '50% 50%'), T_('e2', '50% 45%'), T_('e0', '50% 50%'), T_('e1', '50% 50%'), T_('r0', '60% 55%'), T_('r1', '50% 50%'), T_('e3', '45% 90%', '200%'), T_('e0', '50% 45%', '240%'), T_('e2', '30% 30%', '220%'), T_('r1', '12% 55%', '230%'), T_('e1', '45% 50%', '230%'), T_('r0', '82% 50%', '220%')],
            chat: ['Dana & Eli', 'Buyers', 'e3', 'Saturday showings, all 5 homes', 'The 5 homes we\'re seeing Saturday, all the photos', 'Dana', 'The one with the pool!!', 'Eli', 'Can we see the modern one first?'],
            cap2: 'The client chat',
        },
        trip: {
            h: 'Trip photos, without the HEIC problem',
            p: 'Turn the whole trip into JPGs, then share one album that opens on every phone, Android included.',
            a: [['link', 'Share one album link'], ['download', 'Download them all'], ['door:prints', 'Order prints'], ['door:photo_book', 'Make a photo book']],
            album: ['Paris', 'April 2026 · 184 photos, 6 videos'],
            tiles: [T_('p2', '50% 55%'), T_('p3', '40% 50%'), T_('p5', '40% 55%'), T_('p6', '50% 55%'), T_('p0', '60% 50%'), T_('p1', '50% 68%'), T_('p4', '30% 55%'), T_('p5', '20% 40%', '210%'), T_('p3', '14% 28%', '230%'), T_('p0', '85% 85%', '220%'), T_('p6', '50% 60%', '230%'), T_('p4', '27% 48%', '240%')],
            chat: ['Paris crew', 'Noa, Ben, Tal, you', 'p3', 'Paris, all 184 photos', 'All our Paris photos, full size', 'Ben', 'The ones you AirDropped wouldn\'t open on my Android. These do', 'Noa', 'Printing the bridge one for the fridge'],
            cap2: 'The group chat',
        },
        form: {
            h: 'A photo for a form',
            p: 'School, job, visa and insurance forms often reject HEIC. Convert it to a JPG they accept, in a few seconds.',
            a: [['download', 'Convert it to JPG', 'Get a JPG the form accepts, in a few seconds.'], ['door:size_limit', 'Make it fit the upload limit']],
            form: true,
            cap1: 'The form',
        },
        other: { h: 'Tell us what they\'re for', p: 'We\'re deciding what to build next. One sentence helps.', a: [], solo: true },
    };
    const EV_DESK = {
        sneak_peek: { tab: 'Sneak peeks', h: 'Sneak peeks, the night of the wedding', p: 'Send the couple your 40 favorites before they wake up. One link that opens on any phone, with vertical crops ready for their stories.', a: [['link', 'Send the sneak-peek link'], ['email', 'Email it to the couple'], ['door:auto_pick', 'Let JPEGmini pick the favorites']], album: ['Ana & Luis', 'Sneak peek · 40 photos, 1 teaser'], tiles: [T_('i13', '50% 50%'), T_('i9', '50% 40%'), T_('i2', '60% 55%'), T_('i12', '45% 40%'), T_('i0', '40% 40%'), T_('i7', '50% 55%'), T_('i14', '50% 50%'), T_('i1', '60% 55%'), T_('i5', '50% 45%'), T_('i11', '50% 40%'), T_('i15', '70% 60%', '200%', '0:58'), T_('i3', '50% 40%')], chat: ['Ana & Luis', 'The couple', 'i9', 'Ana & Luis, sneak peek', 'A few favorites from today. The full gallery comes in six weeks', 'Ana', 'We\'re crying!! Posting this one now', 'Luis', 'Already sent it to my mom'], cap2: 'The couple' },
        gallery: { tab: 'The full gallery', h: 'The whole wedding, in one link', p: 'Every photo and the film in one gallery with your name on it. On Pro, the link stays up until you delete it.', a: [['link', 'Send the gallery link'], ['email', 'Email it to the couple'], ['door:proofing', 'Let them pick favorites for the album'], ['door:prints', 'Let them order prints']], album: ['Ana & Luis', 'Mexico, July 2026 · 412 photos, 2 films'], tiles: [T_('i15', '50% 50%', 'cover', '4:12'), T_('i6', '40% 40%'), T_('i2', '60% 55%'), T_('i1', '62% 55%'), T_('i13', '50% 50%'), T_('i4', '45% 50%'), T_('i8', '45% 45%', 'cover', '0:58'), T_('i3', '50% 55%'), T_('i9', '50% 45%'), T_('i5', '50% 40%'), T_('i10', '50% 35%'), T_('i11', '50% 40%')], chat: ['Family', 'Mom, Dad, Grandma, Leo', 'i10', 'Ana & Luis, the wedding', 'Our wedding photos are here!!', 'Mom', 'Crying already. Sending to grandma', 'Leo', 'Who shot this?? So good'], cap2: 'The family chat' },
        film: { tab: 'The film', play: true, h: 'Your film, playing on their phone', p: 'Send the film and the teaser with the photos. They play straight away on a phone, even on hotel wifi, with every frame and grade as you made them.', a: [['link', 'Send the film link'], ['email', 'Email it to the couple'], ['download', 'Download the lighter film']], album: ['Ana & Luis, the film', '4:12 film · 0:58 teaser · 412 photos'], tiles: [T_('i15', '50% 50%', 'cover', '4:12'), T_('i8', '45% 45%', 'cover', '0:58'), T_('i7', '50% 55%'), T_('i9', '50% 45%'), T_('i13', '50% 50%'), T_('i12', '45% 40%'), T_('i6', '40% 40%'), T_('i5', '50% 45%'), T_('i2', '60% 55%'), T_('i14', '50% 50%'), T_('i0', '40% 40%'), T_('i11', '50% 40%')], chat: ['Ana & Luis', 'The couple', 'i15', 'Ana & Luis, the film', 'Your film is here! Watch it with sound', 'Ana', 'Watched it three times already', 'Luis', 'Playing it at brunch tomorrow'], cap2: 'The couple' },
        vendors: { tab: 'Vendors', h: 'A set of photos for every vendor', p: 'Send the planner, venue and florist their own photos from the day, credited to you, so they post your work.', a: [['link', 'Send each vendor a link'], ['email', 'Email the vendors'], ['door:vendor_sets', 'Make vendor sets automatically']], album: ['For Bloom & Co.', 'Ana & Luis, florals · 18 photos'], tiles: [T_('i12', '45% 30%'), T_('i5', '50% 40%'), T_('i10', '50% 80%', '200%'), T_('i1', '60% 55%'), T_('i12', '42% 15%', '230%'), T_('i9', '50% 45%'), T_('i10', '50% 40%'), T_('i1', '35% 60%', '220%'), T_('i13', '50% 50%'), T_('i5', '55% 25%', '220%'), T_('i6', '40% 40%'), T_('i2', '60% 55%')], chat: ['Bloom & Co.', 'Florist', 'i12', 'Ana & Luis, florals', 'Your florals from Saturday. Please tag us when you post', 'Bloom & Co.', 'These are stunning, posting today!', 'Bloom & Co.', 'Can we use a few on our website?'], cap2: 'The vendor chat' },
        team: { tab: 'Second shooter or lab', h: 'Files to your second shooter or album lab', p: 'Swap exports with your second shooter, or send your selects to the album lab, lighter and in one link.', a: [['link', 'Send a link'], ['door:upload_link', 'Get a link they can upload to'], ['door:lab', 'Send selects straight to my album lab']], album: ['Reception, for Maya', 'Ana & Luis · 236 photos'], tiles: [T_('i4', '45% 50%'), T_('i6', '40% 40%'), T_('i11', '50% 40%'), T_('i3', '50% 50%'), T_('i10', '50% 35%'), T_('i7', '50% 55%'), T_('i8', '45% 45%'), T_('i14', '50% 50%'), T_('i4', '30% 70%', '200%'), T_('i6', '70% 30%', '200%'), T_('i15', '40% 60%', '200%'), T_('i10', '30% 60%', '200%')], chat: ['Maya', 'Second shooter', 'i4', 'Ana & Luis, reception', 'The reception set for you to edit', 'Maya', 'Got it, downloading now', 'Maya', 'Way faster than the hard drive'], cap2: 'The team chat' },
        other: { tab: 'Something else', h: 'Tell us what you send', p: 'We\'re deciding what to build next. One sentence helps.', a: [], solo: true },
    };
    let EV_DEFAULT = 'graduation';
    if (state.vKey === 'desktop') {
        EV = EV_DESK;
        EV_DEFAULT = 'sneak_peek';
        $('evTabs').innerHTML = Object.keys(EV).map((k, n) => `<button type="button" role="tab" class="ev-tab" data-ev="${k}" aria-selected="${n ? 'false' : 'true'}">${EV[k].tab}</button>`).join('');
    }
    const ic = (d) => `<svg viewBox="0 0 24 24"><path d="${d}" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
    const ACT = {
        link: { icon: ic('M10 14a4.5 4.5 0 0 0 6.4 0l3-3a4.5 4.5 0 0 0-6.4-6.4l-1 1M14 10a4.5 4.5 0 0 0-6.4 0l-3 3a4.5 4.5 0 0 0 6.4 6.4l1-1'), d: 'Convert them, then get one link that opens every photo on any phone.' },
        email: { icon: ic('M3 6.5h18v11H3zM3 7l9 6 9-6'), d: 'Convert them, and we email the album to the people you choose.' },
        download: { icon: ic('M12 4v11M7.5 10.5 12 15l4.5-4.5M5 19.5h14'), d: 'Convert them and download every JPG in one zip.' },
        'door:prints': { icon: ic('M7 9V3.5h10V9M5 9h14a2 2 0 0 1 2 2v5h-4M3 16v-5a2 2 0 0 1 2-2M7 14h10v6.5H7z'), d: 'Pick your favorites and get them printed and delivered.' },
        'door:photo_book': { icon: ic('M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5zM4 20.5A2.5 2.5 0 0 0 6.5 23H20v-5'), d: 'Turn the album into a printed photo book.' },
        'door:size_limit': { icon: ic('M4 9V4h5M20 15v5h-5M4 4l6 6M20 20l-6-6'), d: 'Set a maximum size and every photo fits the upload limit.' },
        'door:auto_pick': { icon: ic('M12 3v4M12 17v4M3 12h4M17 12h4'), d: '' },
        'door:proofing': { icon: ic('M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z'), d: '' },
        'door:vendor_sets': { icon: ic('M16 20v-1.5a3.5 3.5 0 0 0-3.5-3.5h-5A3.5 3.5 0 0 0 4 18.5V20'), d: '' },
        'door:upload_link': { icon: ic('M12 20V9M7.5 13.5 12 9l4.5 4.5M5 4.5h14'), d: '' },
        'door:lab': { icon: ic('M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z'), d: '' },
    };
    const bgOf = (k) => `url('${assetBg(k)}')`;

    function showEv(u, byUser) {
        const E = EV[u];
        if (!E) return;
        if (byUser) { state.useCase = u; trackHomeEvent('home_use_case_selected', { use_case: u }); }
        document.querySelectorAll('.ev-tab').forEach((t) => t.setAttribute('aria-selected', t.dataset.ev === u ? 'true' : 'false'));
        $('evH').textContent = E.h;
        $('evP').textContent = E.p;
        $('useNote').hidden = true;
        $('useOther').hidden = u !== 'other';
        $('evBody').classList.toggle('solo', !!E.solo);
        $('evArt').hidden = !!E.solo;
        const box = $('evActs');
        box.innerHTML = '';
        box.hidden = !E.a.length;
        $('evActsH').hidden = !E.a.length;
        E.a.forEach((a) => {
            const I = ACT[a[0]] || ACT.download;
            const btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'act-row';
            btn.innerHTML = `<span class="act-ic" aria-hidden="true">${I.icon}</span><span class="act-tx"><b></b><small></small></span><span class="act-go"><em>Start</em><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;
            btn.querySelector('b').textContent = a[1];
            btn.querySelector('small').textContent = a[2] || I.d;
            btn.addEventListener('click', () => {
                if (!state.useCase) state.useCase = u;
                if (a[0].startsWith('door:')) {
                    if (btn.classList.contains('noted')) return;
                    trackHomeEvent('home_fake_door_clicked', { feature: a[0].slice(5), placement: 'use_case' });
                    btn.classList.add('noted');
                    btn.querySelector('small').textContent = 'Coming soon. Thanks, that helps us decide what to build next.';
                    btn.querySelector('.act-go em').textContent = 'Coming soon';
                    return;
                }
                trackHomeEvent('home_use_case_action', { action: a[0] });
                setMode(a[0]);
                focusCard(false);
            });
            box.appendChild(btn);
        });
        if (E.solo) {
            if (byUser) setTimeout(() => $('useText')?.focus(), 50);
            return;
        }
        const art = $('evArt');
        art.classList.toggle('form-mode', !!E.form);
        $('evAlbum').hidden = !!E.form;
        $('evForm').hidden = !E.form;
        $('evCap1').textContent = E.cap1 || 'The album';
        if (E.form) return;
        art.classList.add('swap');
        setTimeout(() => {
            $('evAlbumT').textContent = E.album[0];
            $('evAlbumS').textContent = E.album[1];
            $('evGrid').innerHTML = E.tiles.map((t) => `<i style="background-image:${bgOf(t[0])};background-position:${t[1]};background-size:${t[2]}">${t[3] ? `<em>${t[3]}</em>` : ''}</i>`).join('');
            art.classList.toggle('no-play', !E.play);
            const C = E.chat;
            $('evChatT').textContent = C[0];
            $('evChatS').textContent = C[1];
            $('evAva').style.background = `${bgOf(C[2])} 50% 40% / cover`;
            $('evBubImg').style.backgroundImage = bgOf(C[2]);
            $('evBubT').textContent = C[3];
            $('evM0').textContent = C[4];
            $('evN1').textContent = C[5];
            $('evM1').textContent = C[6];
            $('evN2').textContent = C[7];
            $('evM2').textContent = C[8];
            $('evCap2').textContent = E.cap2;
            art.classList.remove('swap');
            if (byUser && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                const ch = $('evChat');
                ch.classList.remove('play', 'done');
                void ch.offsetWidth;
                ch.classList.add('play');
                setTimeout(() => ch.classList.add('done'), 700);
            }
        }, byUser ? 220 : 0);
    }

    document.querySelectorAll('.ev-tab').forEach((t) => {
        t.addEventListener('click', () => showEv(t.dataset.ev, true));
    });
    if ($('evBody')) showEv(EV_DEFAULT, false);
    $('useSend')?.addEventListener('click', () => {
        const t = $('useText')?.value.trim();
        if (!t) { $('useText')?.focus(); return; }
        state.useCase = 'other';
        trackHomeEvent('home_use_case_other', { text: t.slice(0, 140) });
        $('useOther').hidden = true;
        $('useNote').textContent = 'Thanks. Now drop your photos at the top and they\'re JPGs in a minute.';
        $('useNote').hidden = false;
    });
    $('useText')?.addEventListener('keydown', (e) => { if (e.key === 'Enter') $('useSend')?.click(); });
}

function initHtjExtras() {
    document.querySelectorAll('#faqHtj summary').forEach((sm) => {
        sm.setAttribute('role', 'button');
        const d = sm.parentNode;
        sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
        sm.addEventListener('click', (e) => {
            e.preventDefault();
            d.open = !d.open;
            sm.setAttribute('aria-expanded', d.open ? 'true' : 'false');
            if (d.open) {
                const question = sm.textContent?.trim();
                if (question) trackHomeEvent('home_faq_opened', { question });
            }
        });
    });
    const f = document.querySelector('#howHtj .flow');
    const n = $('ringN');
    if (f && n && state.vKey === 'htj' && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        n.textContent = '0';
        new IntersectionObserver((entries, o) => {
            entries.forEach((e) => {
                if (!e.isIntersecting) return;
                o.disconnect();
                setTimeout(() => {
                    const t0 = Date.now();
                    const D = 1400;
                    const step = () => {
                        const k = Math.min(1, (Date.now() - t0) / D);
                        const ease = 1 - Math.pow(1 - k, 3);
                        n.textContent = String(Math.round(212 * ease));
                        if (k < 1) requestAnimationFrame(step);
                    };
                    step();
                }, 200);
            });
        }, { threshold: 0.5 }).observe(f);
    }
}

export function initPublicHomeVariants(uploadApi) {
    const vKey = resolveVariantKey();
    state = { vKey, V: VARIANTS[vKey] || VARIANTS.web, T: (VARIANTS[vKey] || VARIANTS.web).t || {}, useCase: null };
    document.body.classList.add(`v-${vKey}`);
    if (!getWallsForVariant(vKey).length && state.V.walls === 'everyday') {
        document.body.classList.add('no-walls');
    }
    applyCopy();
    layoutForVariant();
    if (state.vKey === 'htj') initHtjExtras();
    if ((state.vKey === 'htj' || state.vKey === 'desktop') && $('hUse')) {
        initUseCases(uploadApi);
    }
    return state;
}

export function applyVariantToUploadOptions({ setMode }) {
    const { V } = state;
    if (V.optOrder) {
        const og = document.querySelector('.opts');
        const prints = $('optPrints');
        V.optOrder.forEach((m) => {
            const el = document.querySelector(`.opt[data-m="${m}"]`);
            if (el && og && prints) og.insertBefore(el, prints);
        });
    }
    if (V.fakePrints && $('optPrints')) {
        $('optPrints').hidden = false;
        $('optPrints').addEventListener('click', () => {
            trackHomeEvent('home_fake_door_clicked', { feature: 'prints', placement: 'card' });
            $('optPrints').classList.add('noted');
            $('optPrintsSub').textContent = 'Coming soon. We\'ll let you know.';
            const em = $('email')?.value.trim();
            $('doorNote').textContent = `Prints are coming soon. We'll email you${em ? ` at ${em}` : ''} when you can order them. For now, choose how to get your photos.`;
            $('doorNote').hidden = false;
        });
    }
    if (V.mode) setMode(V.mode);
}

export function getVariantSayLines() {
    const { V } = state;
    return {
        add: V.say?.add ? [V.say.add[0], V.say.add[1], true] : null,
        work: V.say?.work ? [V.say.work[0], V.say.work[1], false] : null,
        done: V.say?.done ? [V.say.done[0], V.say.done[1], false] : null,
    };
}
